import { LanguageCode } from '@navio/nsdk';

export const getLanguagePropertiesFromCountryCode = (languageCode?: LanguageCode) => {
  switch (languageCode) {
    case 'en-us':
      return {
        name: 'English',
        flag: '🇬🇧'
      };
    case 'nb':
      return {
        name: 'Norwegian',
        flag: '🇳🇴'
      };
    case 'sv':
      return {
        name: 'Swedish',
        flag: '🇸🇪'
      };
    case 'de':
      return {
        name: 'German',
        flag: '🇩🇪'
      };
    default:
      return {
        name: 'Unknown',
        flag: ''
      };
  }
};
